import * as types from '../constants/ActionTypes';


const INITIAL_STATE = {
    id: 0,
    url: '/',
    error: null,
};

export default function attachmentReducer(state = INITIAL_STATE, action) {
    switch (action.type) {
        // error: null ensures the UI is updated should an error occur in between successful requests.
        case types.GET_ATTACHMENT_SUCCESS:
            return {
                ...state,
                id: action.response.id,
                url: action.response.url,
                error: null,
            };

        case types.GET_ATTACHMENT_ERROR:
            return {
                ...state,
                id: action.id,
                url: INITIAL_STATE.url,
                error: action.response,
            };

        default:
            return state;
    }
}